import React from 'react';
import Slider from 'react-slick';
import css from './Section.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { ListingCard } from '../../../components';

const sliderSettings = isMobileLayout => ({
  dots: isMobileLayout,
  arrows: !isMobileLayout,
  infinite: false,
  autoplaySpeed: 3000,
  autoplay: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 1280,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 990,
      settings: { slidesToShow: 2, dots: true, arrows: false },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, dots: true, arrows: false },
    },
    {
      breakpoint: 550,
      settings: { slidesToShow: 1, dots: true, arrows: false },
    },
  ],
});

function SectionBestSeller({ viewport, listings = [] }) {
  const isMobileLayout = viewport?.width > 0 && viewport.width < 768;

  const featuredListings = listings.filter(l => l?.attributes?.publicData?.isFeatured === true);
  const sortedListings = [...listings].sort((a, b) => {
    const aTime = new Date(a?.attributes?.createdAt || 0).getTime();
    const bTime = new Date(b?.attributes?.createdAt || 0).getTime();
    return bTime - aTime;
  });
  const items = (featuredListings.length > 0 ? featuredListings : sortedListings).slice(0, 8);

  return (
    <div className={css.bestSellerProductSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          {/* <span>Ready to Buy?</span> */}
          <h2>Featured Items</h2>
        </div>
        <div className={css.testimonialSlider}>
          {items.length > 0 ? (
            <Slider {...sliderSettings(isMobileLayout)}>
              {items.map(l => (
                <ListingCard
                  className={css.listingCard}
                  key={l?.id?.uuid}
                  listing={l}
                  setActiveListing={() => {}}
                />
              ))}
            </Slider>
          ) : (
            <p>No featured items available yet.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionBestSeller;
